import { Chip, alpha } from '@mui/material';
import type { Theme } from '@mui/material/styles';

export type StatusChipKind =
  'success' | 'warning' | 'info' | 'neutral' | 'primary';

type StatusChipProps = { label: string; kind?: StatusChipKind };

const colorsFor = (
  theme: Theme,
  kind: StatusChipKind
): { fg: string; bg: string } => {
  switch (kind) {
    case 'success':
      return {
        fg: theme.palette.success.main,
        bg: alpha(theme.palette.success.main, 0.16),
      };
    case 'warning':
      return {
        fg: theme.palette.warning.main,
        bg: alpha(theme.palette.warning.main, 0.16),
      };
    case 'info':
      return {
        fg: theme.palette.info.main,
        bg: alpha(theme.palette.info.main, 0.16),
      };
    case 'primary':
      return {
        fg: theme.palette.primary.main,
        bg:
          theme.palette.primary.selected ??
          alpha(theme.palette.primary.main, 0.08),
      };
    case 'neutral':
    default:
      return {
        fg: theme.palette.text.secondary,
        bg: theme.palette.action.hover,
      };
  }
};

/** Status pill. */
export const StatusChip = ({ label, kind = 'neutral' }: StatusChipProps) => (
  <Chip
    label={label}
    size="small"
    sx={theme => {
      const c = colorsFor(theme, kind);
      return {
        height: 'auto',
        borderRadius: 999,
        color: c.fg,
        backgroundColor: c.bg,
        fontSize: 12,
        fontWeight: 600,
        '& .MuiChip-label': { px: 1.25, py: 0.375 },
      };
    }}
  />
);
